<mat-icon
  class="mat-icon-xs text-premium"
  fontSet="material-symbols-outlined">
  lock
</mat-icon>
